import { AUTH_LOGIN, AUTH_LOGOUT } from "./actionTypes";
import { setData } from "../data/actions";
import BACKEND_URL from "../../utils/constants";

const authLogin = (user) => {
  return { type: AUTH_LOGIN, payload: { user } };
};

export const tryLogin = (userInfo) => async (dispatch) => {
  const url = `${BACKEND_URL}/login/`;
  console.log("api url ", url);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(userInfo),
  });

  const res = await response.json();

  if (Object.keys(res.user).length > 0) {
    console.log("DATA ", res.data);
    dispatch(authLogin(res.user));
    dispatch(setData(res.data));
  } else {
    console.log("Login Faliure");
    alert("Error en usuario y clave");
  }
};

export const authLogout = () => {
  return { type: AUTH_LOGOUT, payload: {} };
};
